<ng-container *ngIf="systemBetPick">
    <div class="betslip-digital-bet-pick-column-0">
        <ng-container *ngIf="isSelectionCheckboxVisible">
            <bs-digital-pick-selection
                [pick]="pick"
                [selection]="systemBetPick"
                [isLinear]="(isLinear$ | async) ?? false"
                [betslipType]="betslipType" />
            <bs-digital-combo-prevention-indicator [pick]="pick" [betslipType]="betslipType" />
        </ng-container>
    </div>
    <div
        class="betslip-digital-bet-pick-column-1 {{ pickClass }}"
        [ngClass]="{ 'betslip-digital-bet-pick-column-1--banker': isBankerActive$ | async }"
        (click)="eventClick()">
        <bs-digital-pick-odds [pick$]="pickChange$" [oddsDisplayFormat]="oddsDisplayFormat" />
        <ng-container
            *ngTemplateOutlet="
                pickTemplate;
                context: {
                    pick: pick,
                    betslipType: betslipType,
                    messages: messages,
                    showEachWay: systemBetState.isEachWay,
                    hideLineSwitcher: isLinear$ | async,
                    marketLogoTooltipAppendTo: 'bs-betslip-edit-state',
                    marketLogoTooltipBoundaries: 'bs-betslip-edit-state',
                    marketLogoTooltipPlacement: 'bottom-start',
                    marketLogoTrackingLocation: 'betslip',
                }
            " />
        <button
            class="betslip-digital-pick__banker-btn"
            *ngIf="isBankerActive$ | async"
            [class.selected]="systemBetPick.isBanker"
            (click)="toggleBanker($event, pick)">
            {{ messages.common.BankerAbbr }}
        </button>
    </div>
    <div class="betslip-digital-bet-pick-column-2">
        <bs-digital-pick-remove-button *ngIf="isRemoveButtonVisible" [removeButtonStyle]="removeButtonStyle" (remove)="removePick()" />
    </div>
    <bs-tabbed-pick-errors *ngIf="!(isLinear$ | async)" [pickId]="pick.id" [betslipType]="betslipType" />
</ng-container>
